var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorSvg = function SvgErrorSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C52828",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.413 13.413c2.556 0 5.111.977 7.067 2.93a9.986 9.986 0 0 1 0 14.138 9.984 9.984 0 0 1-14.136 0 9.986 9.986 0 0 1 0-14.137 9.966 9.966 0 0 1 7.07-2.93Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.351 23.413 2.864-2.858a.669.669 0 0 0-.946-.946l-2.857 2.864-2.857-2.864a.669.669 0 1 0-.946.946l2.864 2.858-2.864 2.857a.666.666 0 0 0 0 .946.666.666 0 0 0 .946 0l2.857-2.864 2.857 2.864a.666.666 0 0 0 .946 0 .666.666 0 0 0 0-.946l-2.864-2.857Z",
    fill: "#C52928"
  })))));
};
export default SvgErrorSvg;